import { createSelector } from 'reselect';

export const customerLoanSelector = createSelector(
    (state) => state && state.loan && state.loan.customerLoanHistory,
    (history) => history,
);

export const borrowersSelector = createSelector(
    (state) => state && state.loan && state.loan.borrowers,
    (borrowers) => borrowers || [],
);

export const totalOutstandingSelector = createSelector(
    (state) => state && state.loan && state.loan.totalOutstanding,
    (total) => total || 0,
);

export const activeLoansSelector = createSelector(
    (state) => state && state.loan && state.loan.activeLoans,
    (count) => count || 0,
);

export const interestEarningCountSelector = createSelector(
    (state) => state && state.loan && state.loan.interestEarningCount,
    (count) => count || 0,
);

export const monthlyInterestIncomeSelector = createSelector(
    (state) => state && state.loan && state.loan.monthlyInterestIncome,
    (amount) => amount || 0,
);
